import Money from "common/values/money/money";

export default class Fee {
  rate?: Money;
  unit?: string;
  isFixed: boolean;

  constructor(rate?: Money, unit?: string, isFixed?: boolean) {
    this.rate = rate;
    this.unit = unit;
    this.isFixed = isFixed ?? false;
  }

  public static areSame(original: Fee, updated: Fee): boolean {
    if (!original || !updated) return false;

    const ratesEqual =
      (!original.rate && !updated.rate) ||
      Boolean(original.rate?.isEqualTo(updated.rate));

    return (
      ratesEqual &&
      original.unit === updated.unit &&
      original.isFixed === updated.isFixed
    );
  }
}
